import type { ReactNode } from 'react';
import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme, type ThemePreference } from './ThemeProvider';

const btn =
  'flex h-9 w-9 items-center justify-center rounded-lg border border-transparent text-ct-muted transition hover:bg-ct-elevated hover:text-ct-text focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ct-accent';

const active = 'border-ct-border bg-ct-elevated text-ct-accent';

export function ThemeToggle({ className = '' }: { className?: string }) {
  const { preference, setPreference } = useTheme();

  const item = (p: ThemePreference, label: string, icon: ReactNode) => (
    <button
      type="button"
      className={`${btn} ${preference === p ? active : ''}`}
      aria-pressed={preference === p}
      aria-label={label}
      title={label}
      onClick={() => setPreference(p)}
    >
      {icon}
    </button>
  );

  return (
    <div
      className={`inline-flex rounded-xl border border-ct-border bg-ct-surface p-0.5 ${className}`}
      role="group"
      aria-label="Thema"
    >
      {item('light', 'Licht thema', <Sun className="h-4 w-4" aria-hidden />)}
      {item('dark', 'Donker thema', <Moon className="h-4 w-4" aria-hidden />)}
      {item('system', 'Systeemthema', <Monitor className="h-4 w-4" aria-hidden />)}
    </div>
  );
}
